import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import { Facebook } from '@finect/tabular-icons/facebook';
import { Twitter } from '@finect/tabular-icons/twitter';
import { Linkedin } from '@finect/tabular-icons/linkedin';
import { WhatsApp } from '@finect/tabular-icons/whatsapp';
import { Mail } from '@finect/tabular-icons/mail';
import { dataLayer } from '@finect/front-gtm';
import { CardInner } from '../commons/CardInner';
import { ShareCard } from './ShareCard';
import { ShareLink } from './ShareLink';
export var ShareContent = function ShareContent(_ref) {
  var title = _ref.title,
    url = _ref.url,
    via = _ref.via,
    position = _ref.position,
    arrowPosition = _ref.arrowPosition;
  var handleClick = function handleClick(event, medium) {
    var targetURL = event.target.getAttribute('href');
    if (!event.target.getAttribute('href')) return;
    event.preventDefault();
    var width = 550;
    var height = 480;
    var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
    var top = (window.screenY || window.screenTop || 0) + (window.outerHeight - window.innerHeight);
    var config = {
      width: width,
      height: height,
      left: left,
      top: top,
      location: 'no',
      toolbar: 'no',
      status: 'no',
      directories: 'no',
      menubar: 'no',
      scrollbars: 'yes',
      resizable: 'no',
      centerscreen: 'yes',
      chrome: 'yes'
    };
    dataLayer({
      id: 'Share',
      type: 'shareClick',
      params: {
        medium: medium,
        url: url
      }
    });
    window.open(targetURL, '', Object.keys(config).map(function (key) {
      return "".concat(key, "=").concat(config[key]);
    }).join(', '));
  };
  var getURL = function getURL(sharedURL, source) {
    var medium = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Social';
    var hasParams = function hasParams(checkURL) {
      var des = checkURL.split('?');
      if (des.length > 1 && des[1] !== '') return '&';
      return '?';
    };
    return encodeURIComponent("".concat(sharedURL).concat(hasParams(sharedURL), "utm_source=").concat(source, "&utm_medium=").concat(medium, "&utm_campaign=social_buttons"));
  };
  var parseTitle = function parseTitle(text) {
    var titleEncoded = text.replace(/%/g, '%25');
    return titleEncoded;
  };
  return React.createElement(ShareCard, {
    posX: position.x,
    posY: position.y
  }, React.createElement(CardInner, {
    posX: position.x,
    posY: position.y,
    arrowPos: arrowPosition
  }, React.createElement(ShareLink, {
    color: "#325a97"
  }, React.createElement("a", {
    href: "https://www.facebook.com/sharer/sharer.php?text=".concat(title, "&u=").concat(getURL(url, 'Facebook')),
    onClick: function onClick(event) {
      handleClick(event, 'Facebook');
    }
  }, React.createElement(Facebook, null), "Facebook")), React.createElement(ShareLink, {
    color: "#00aced"
  }, React.createElement("a", {
    href: "https://twitter.com/intent/tweet?text=".concat(parseTitle(title), "&url=").concat(getURL(url, 'Twitter'), "&via=").concat(via),
    onClick: function onClick(event) {
      handleClick(event, 'Twitter');
    }
  }, React.createElement(Twitter, null), "Twitter")), React.createElement(ShareLink, {
    color: "#0077b5"
  }, React.createElement("a", {
    href: "http://www.linkedin.com/shareArticle?mini=true&source=".concat(via, "&title=").concat(title, "&url=").concat(getURL(url, 'LinkedIn')),
    onClick: function onClick(event) {
      handleClick(event, 'LinkedIn');
    }
  }, React.createElement(Linkedin, null), "LinkedIn")), React.createElement(ShareLink, {
    color: "#07bc4c"
  }, React.createElement("a", {
    href: "https://api.whatsapp.com/send?text=".concat(getURL(url, 'WhatsApp')),
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function onClick(event) {
      handleClick(event, 'WhatsApp');
    }
  }, React.createElement(WhatsApp, null), "WhatsApp")), React.createElement(ShareLink, null, React.createElement("a", {
    href: "mailto:?subject=".concat(title, "&body=").concat(getURL(url, 'emailsharing', 'email')),
    onClick: function onClick(event) {
      handleClick(event, 'Email');
    }
  }, React.createElement(Mail, {
    size: "16"
  }), "Email"))));
};